// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__SWRSY","log":"ModalInventoryLogs_log__31Ffj","date":"ModalInventoryLogs_date__95OA9","userName":"ModalInventoryLogs_userName__24sIg"};